<template>
  <span
    class="nav-icon"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
      maskImage: `url(${src})`,
      WebkitMaskImage: `url(${src})`,
    }"
    aria-hidden="true"
  />
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>

<style scoped>
.nav-icon {
  display: inline-block;
  flex-shrink: 0;
  background-color: currentColor;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;
}
</style>
